let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4shhd"), load("gr9Xf")]).then(() => parcelRequire('iFpSu'));